export const paletteColors = [
  // row 1
  '#8096A1',
  '#CC3E20',
  '#EE752F',
  '#F9D649',
  '#BBE749',
  '#85D947',
  '#5AC462',
  '#51B6D1',
  '#3C91E3',
  '#3466F6',
  '#5823E1',
  '#9B2FF6',
  '#B52C62',
  // row 2
  '#C4D1D8',
  '#EC4F27',
  '#F19637',
  '#FCE94F',
  '#D2FC51',
  '#9BFA4E',
  '#69E282',
  '#66E2FC',
  '#4CAFF9',
  '#3D7BF7',
  '#5B33F5',
  '#C336F0',
  '#E1315A',
  // row 3
  '#FFFFFF',
  '#EE764E',
  '#F4AE56',
  '#FFFE55',
  '#E4FD67',
  '#C3FC73',
  '#8EECB3',
  '#76FCFD',
  '#67C3FA',
  '#548BF7',
  '#7456F6',
  '#CF54F3',
  '#EC5281',
];

export const TRANSPARENT_HEX = '#00000000';

export const paletteColorsWithTransparent = paletteColors.map((color, i) => {
  return i === 0 ? TRANSPARENT_HEX : color;
});
